<template>
  <div
    class="dropzone"
    :class="{ dragging }"
  >
    <tooltip
      v-if="dragging"
      :position="tooltipPosition"
    >
      <slot />
    </tooltip>
  </div>
</template>

<script>
import Tooltip from '@/components/editor/Tooltip'

export default {
  name: 'Dropzone',
  inheritAttrs: false,
  components: {
    Tooltip
  },
  props: {
    target: {
      type: Object,
      default: undefined
    },
    validationFn: {
      type: Function,
      default: () => {
        return () => true
      }
    }
  },
  data () {
    return {
      dragging: false,
      tooltipPosition: {}
    }
  },
  computed: {
    eventTarget () {
      return this.target || this.$parent
    }
  },
  methods: {
    onDragOver (e) {
      if (this.$root.$store.state.editMode && this.validationFn(e)) {
        this.tooltipPosition = {
          x: e.clientX,
          y: e.clientY
        }
        this.dragging = true
      }
    },
    onDragLeave (e) {
      if (this.$root.$store.state.editMode && this.validationFn(e)) {
        this.tooltipPosition = {}
        this.dragging = false
      }
    },
    onDrop (e) {
      if (this.$root.$store.state.editMode && this.validationFn(e)) {
        this.tooltipPosition = {}
        this.dragging = false
        this.$emit('drop', e)
      }
    }
  },
  mounted () {
    const preventEvents = ['dragover', 'dragenter', 'dragleave', 'drop']

    for (const evt of preventEvents) {
      this.eventTarget.$el.addEventListener(evt, (e) => {
        e.preventDefault()
        e.stopPropagation()
      }, false)
    }

    this.eventTarget.$el.addEventListener('drop', this.onDrop)
    this.eventTarget.$el.addEventListener('dragenter', this.onDragOver)
    this.eventTarget.$el.addEventListener('dragover', this.onDragOver)
    this.eventTarget.$el.addEventListener('dragleave', this.onDragLeave)
  },
  beforeDestroy () {
    this.eventTarget.$el.removeEventListener('drop', this.onDrop)
    this.eventTarget.$el.removeEventListener('dragenter', this.onDragOver)
    this.eventTarget.$el.removeEventListener('dragover', this.onDragOver)
    this.eventTarget.$el.removeEventListener('dragleave', this.onDragLeave)
  }
}
</script>

<style lang="scss" scoped>
.dropzone {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  pointer-events: none;
  z-index: 1;

  &.dragging {
    border: 2px solid red !important;
  }
}
</style>
